import { createSelector } from '@reduxjs/toolkit';
import { get, isNil, isEmpty } from 'lodash/fp';
import { GoogleConfigurationStatus } from 'app/lib/constants';

const selectSlice = get('integrations.google');

export const selectIsLoading = createSelector(selectSlice, get('isLoading'));

export const selectError = createSelector(selectSlice, get('error'));

export const selectGoogleCredentials = createSelector(selectSlice, get('googleCredentials'));

export const selectGoogleCredentialsStatus = createSelector(
    selectGoogleCredentials,
    (credentials) => {
        if (isNil(credentials)) {
            return GoogleConfigurationStatus.UNKNOWN;
        }
        if (isEmpty(credentials)) {
            return GoogleConfigurationStatus.NOT_CONFIGURED;
        }
        return GoogleConfigurationStatus.CONFIGURED;
    }
);

export const selectRequestId = createSelector(selectSlice, get('requestId'));

export const selectIsIntegrationUnconfiguredDialogOpen = createSelector(
    selectSlice,
    get('isIntegrationUnconfiguredDialogOpen')
);
